module.exports = __webpack_public_path__ + "static/1-48d2a0005117fbf812462c3559d21463.jpg";